export default __webpack_public_path__ + "static/media/toinhabrasilshow-arena2-300x225.dc62f2eb.png";